module.exports = __webpack_public_path__ + "assets/img/0.2f9a1ed6.png";